"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddUserOrGroupButton = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var Bubble_1 = require("../../../Bubble");
/**
 * @internal
 */
exports.AddUserOrGroupButton = function (props) {
    var isDisabled = props.isDisabled, onClick = props.onClick;
    var buttonClassNames = classnames_1.default({
        disabled: isDisabled,
    }, "gd-button", "gd-button-link", "gd-icon-plus", "s-add-users-or-groups");
    var handleClick = react_1.useCallback(function (e) {
        e.preventDefault();
        if (isDisabled) {
            return;
        }
        onClick();
    }, [isDisabled, onClick]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(Bubble_1.BubbleHoverTrigger, { showDelay: 0, hideDelay: 0 },
            react_1.default.createElement("a", { className: buttonClassNames, target: "_blank", rel: "noopener noreferrer", onClick: handleClick },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "shareDialog.share.grantee.add" })),
            react_1.default.createElement(Bubble_1.Bubble, { className: "bubble-primary", alignPoints: [{ align: "cr cl" }] },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "shareDialog.share.grantee.add.info" })))));
};
//# sourceMappingURL=AddGranteeButton.js.map